var render, staticRenderFns
import script from "./renderHeader.vue?vue&type=script&lang=js"
export * from "./renderHeader.vue?vue&type=script&lang=js"
import style0 from "./renderHeader.vue?vue&type=style&index=0&id=e5180864&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e5180864",
  null
  
)

export default component.exports